import buildQuery from 'odata-query';
//
import { UserDimension } from './users/UserDimension';
import { EventDimension } from './events/EventDimension';
import { Grouping, GroupingType } from './Grouping';
import { ChartType } from '../Chart';
import { switchcase } from 'data/function';
import { v4 as uuid } from 'uuid';
/**
 *
 * Class to handle metric and command requests.
 * All properties started with '$' means 'view properties', not used to make command calls on MessagingHub
 *
 */
export class Metric {
    static $inject = ['init'];
    constructor(init) {
        /**
         * Events dimension filters
         */
        this.events = [];
        // Defaults
        this.grouping = new Grouping({
            type: GroupingType.Total,
        });
        this.$chartType = ChartType.Line;
        this.$isLoading = true;
        this.$showBy = 'events';
        this.$id = uuid(),
            Object.assign(this, init);
    }
    addUserDimension() {
        if (!this.users) {
            this.users = new UserDimension();
        }
    }
    addEventDimension() {
        if (this.events.length == 0) { //Temporaly supports only one eventDimension
            this.events = this.events.concat(new EventDimension());
        }
    }
    removeDimension(dimension) {
        switch (dimension.constructor) {
            case UserDimension:
                this.users = undefined;
                break;
            case EventDimension:
                this.events = [];
                break;
        }
    }
    toOdataFilter({ beginDate, endDate }) {
        const usersDimension = 'user';
        const eventsDimension = 'events';
        let usersFilter;
        let eventsFilter;
        if (this.users) {
            usersFilter = {
                [`${eventsDimension}.${usersDimension}.type`]: this.users.type,
                ...this.users.filters.reduce((props, f) => ({
                    ...props,
                    [`${eventsDimension}.${usersDimension}.extras.${f.prop}`]: { [f.condition]: f.value },
                }), {}),
            };
        }
        if (this.events) {
            eventsFilter = {
                ...this.events.reduce((props, e) => ({
                    ...props,
                    [`${eventsDimension}.category`]: e.category,
                    [e.action ? `${eventsDimension}.action` : '']: e.action,
                    ...e.filters.reduce((filters, f) => ({
                        ...filters,
                        [`${eventsDimension}.extras.${f.prop}`]: { [f.condition]: f.value },
                    }), {}),
                }), {}),
            };
        }
        return buildQuery({
            filter: {
                beginDate,
                endDate,
                ...usersFilter,
                ...eventsFilter,
            },
        });
    }
    static convertChartToMetric(chart) {
        const dimensionType = switchcase({
            'events': {
                events: [new EventDimension({
                        category: chart.category,
                    })],
            },
        })({
            events: [new EventDimension({
                    category: chart.dimension,
                })],
        })(chart.dimension);
        return new Metric({
            $id: chart.id,
            $name: chart.name,
            $chartType: chart.chartType,
            $chartData: chart.data,
            ...dimensionType,
        });
    }
}
Metric.$inject = ['init'];
